export {
  PLUGIN_KEY,
  PLUGIN_PRIORITY,
  PersistentState,
} from './persistentState';
